import type { OrganizationInfoButtonProps } from "./organization-info-button.type";

import { OrganizationInfo } from "@/modules/organization/organization-info";
import { useSidePanel } from "@/modules/side-panel";
import { InfoButton } from "@/ui/info-button";

export const OrganizationInfoButton = ({
  organization,
  ...buttonProps
}: OrganizationInfoButtonProps) => {
  const { openSidePanel } = useSidePanel();

  const onClick = () => {
    openSidePanel({
      title: organization.name,
      component: <OrganizationInfo organizationId={organization.id} />,
    });
  };

  return (
    <InfoButton type="text" icon={null} {...buttonProps} onClick={onClick} />
  );
};
